define('views/abstract-comments/create-form',[
  "globals",
  "backbone"
], function (globals, Backbone) {
  "use strict";

  return Backbone.View.extend({
    refreshInterval: 1500,
    CREATE_EVENT_NAME: "create:comment",

    events: {
      "submit": "submit",
      "click [data-action = cancel]": "reset",
      "click [data-action = browse]": "browse"
    },

    initialize: function () {
      this.$textarea = this.$("textarea");
      this.intervalId = window.setInterval(this.refresh, this.refreshInterval);

      window.onbeforeunload = function () {
        var t = document.getElementById("comment-text");
        if (t.value.length > 0) {
          return true;
        }
      };

      return this;
    },

    render: function () {
      this.$el.slideDown(150, this.scroll);
      this.$el.removeAttr("hidden");
      this.$textarea.focus();
      return this;
    },

    scroll: function () {
      $("html, body").animate({
        scrollTop: globals.getElementPosition($(this))
      }, 250);

      return this;
    },

    submit: function (e) {
      e.preventDefault();

      var json = this.serialize();
      if (!json.content && json.attachment === "") return this.reset();

      if (json.attachment !== "") {
        this.createAttachment(json)
      } else {
        this.createComment(json);
      }

      this.reset();
      setTimeout(function () {
        $(document.getElementById("loadingComments")).show();
        $(document.getElementById("show-form")).hide();       
      }, 0);

    },

    createAttachment: function (json) {
      var thisScope = this;
      var attachForm = document.getElementById("attach-form");
      attachForm.action = attachForm.action.substring(0, attachForm.action.lastIndexOf("/") + 1) + json.created;
      json.attachment = json.created + "_" + json.attachment.replace(/^.*\\/, "");

      $(".file").each(function () {
        if (this.files.length > 0) {
          var data = new FormData();
          this.files[0].filename = json.attachment
          data.append("attachment", this.files[0]);

          $.ajax({
            url: attachForm.action,
            data: data,
            cache: false,
            contentType: false,
            processData: false,
            method: "POST",
            type: "POST", // For jQuery < 1.9
            success: function () {
              thisScope.createComment(json);
            },
            error: function (jqXHR) {
              alert(jqXHR.responseText);
            }
          });
        }

      });

    },

    createComment: function (json) {
      this.collection.create(json, {
        success: _.bind(function (model) {
          this.collection.trigger(this.CREATE_EVENT_NAME, model);
          setTimeout(function () {
            $(document.getElementById("loadingComments")).hide();
            $(document.getElementById("show-form")).show();       
          }, 0);
        }, this)        
      });

    },

    reset: function (e) {
      if (e) e.preventDefault();
      document.getElementById("attach-form").reset();
      document.getElementById("comment-form").reset();
      document.getElementById("reply-form").reset();

      $(document.getElementById("attach-form")).hide();
      $(document.getElementById("comment-form")).hide();
      $(document.getElementById("reply-forms")).hide();

      $(document.getElementById("highlight")).val("");

      this.trigger("reset");
      return this.undelegateEvents();
    },

    refresh: function () {
      var filename = document.getElementById("attachment").value;
      if(filename !== "" && filename !== undefined) {
        document.getElementById("filename").value = filename.replace(/^.*\\/, "");
      }
    },

    browse: function () {
      document.getElementById("attachment").click()
    },

    serialize: function () {
      var json = {
        created: Date.now(),
        content: this.$textarea.val()
      };

      return json;
    }
  });
});

